// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","toggle":"toggle_toggle__eZeym","indicator":"toggle_indicator__tGtAT","active":"toggle_active__0TWsm"};